// Project-level libraries and styles
import 'appeals/shared';
import {unloadSpinner} from 'appdevcommon/common';

//This will allow to use dd() function in javascript too 🔥
global.dd = console.log;

// This is here to ensure that jQuery is available outside of webpack.
if (typeof global.jQuery === 'undefined') {
    global.$ = global.jQuery = jQuery;
}

import 'appeals-css/main.scss';
import 'appdevresources/navigation-menu-builder';
import 'appeals/search-bar';
import { initializeImpersonateUser } from 'appdevresources/common';

$(function() {
    initializeImpersonateUser();
    $(window).on('pageshow', () => unloadSpinner());
});

console.debug('Loaded app: appeals');
